// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-content-page',
    props: {
        widthMode: {
            type: String,
            required: false,
            default: 'full'
        },
        showCommandBar: {
            type: Boolean,
            required: false,
            default: true
        },
    },
});
// #endregion
